<template>

  <div>
    <div
      v-for="(item, index) in nValue"
      :key="index"
      class="form-row">
      <div class="form-group col-md-3">
        <div
          class="form-control">
          {{ item.label }}
          </div>
      </div>
      <div class="form-group col-md-3">
        <select
          class="form-control"
          v-model="item.conditional">
          <!--number-->
          <option
            v-for="option in getConditionalOptions(item.type)"
            :value="option.value">{{ option.name }}</option>
        </select>
        <ValidateMessage :error="validateErrors[`filters.${index}.conditional`]" />
      </div>
      <div
        v-if="!['empty', 'filled'].includes(item.conditional)"
        class="form-group col-md-4">
        <input
          v-if="item.type === 'float'"
          type="text"
          class="form-control"
          v-model="item.value_num">
        <ValidateMessage :error="validateErrors[`filters.${index}.value_num`]" />
        <Select
          v-if="item.type === 'keyword' && item.options"
          v-model="item.values"
          :options="item.options"
          multiple />
        <SelectAjax
          v-if="item.type === 'keyword' && item.filter_module"
          v-model="item.values"
          :options="item.options"
          :search="search(item.filter_module)"
          multiple />
        <ValidateMessage :error="validateErrors[`filters.${index}.values`]" />
        <Select
          v-if="item.type === 'boolean' && item.options"
          v-model="item.value_boo"
          :options="item.options" />
        <ValidateMessage :error="validateErrors[`filters.${index}.value_boo`]" />
      </div>
      <div class="col-md-2">
        <button
          type="button"
          @click="removeFilter(index)">Remover</button>
      </div>
    </div>

    <div class="dropdown">
      <button
        class="btn btn-sm btn-light dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {{ $t('Add filter') }}
      </button>
      <div
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
        style="overflow: auto; max-height: 200px">
        <button
          type="button"
          v-for="filter in filtersNoSelected"
          :key="filter.field"
          class="dropdown-item"
          @click="addFilter(filter)">
          {{ filter.label }}
          </button>
      </div>
    </div>
  </div>

</template>

<script>
import Select from '@/components/Fields/Select'
import SelectAjax from '@/components/Fields/SelectAjax'

export default {
  name: 'DashcomponentFilters',
  components: {
    Select,
    SelectAjax
  },
  props: {
    value: {
      type: Array,
      default: () => { return [] }
    },
    filters: {
      type: Array,
      default: () => { return [] }
    },
    validateErrors: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      nValue: this.$clone(this.value).map(item => {
        const field = this.filters.find(v => v.field === item.field)
        return {
          ...field,
          ...item
        }
      })
    }
  },
  watch: {
    nValue: {
      deep: true,
      handler: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  computed: {
    filtersNoSelected () {
      return this.filters.filter(item => {
        return !this.nValue.find(v => v.field === item.field)
      })
    }
  },
  created () {
  },
  methods: {
    search (_module) {
      return (text, value) => {
        return this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/reporting/builder/filters/' + _module, {
          params: {
            q: text,
            value: value,
            limit: value ? value.length : undefined
          }
        }).then(r => r.data)
      }
    },
    addFilter (data) {
      this.nValue.push({
        ...data,
        conditional: this.getConditionalOptions(data.type)[0].value,
        value: null
      })
    },
    removeFilter (index) {
      this.nValue.splice(index, 1)
    },
    getConditionalOptions (type) {
      if (type === 'float') {
        return [
          { value: 'more_than', name: 'é maior que' },
          { value: 'less_than', name: 'é menor que' },
          { value: 'empty', name: 'está vazio' },
          { value: 'filled', name: 'não está vazio' }
        ]
      }
      if (type === 'keyword') {
        return [
          { value: 'terms', name: 'é um dos valores' }
          // { value: 'not_terms', name: 'não é um dos valores' },
          // { value: 'empty', name: 'está vazio' },
          // { value: 'filled', name: 'não está vazio' }
        ]
      }
      if (type === 'boolean') {
        return [
          { value: 'is', name: 'é' }
          // { value: 'not_terms', name: 'não é um dos valores' },
          // { value: 'empty', name: 'está vazio' },
          // { value: 'filled', name: 'não está vazio' }
        ]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashcomponentFilters.vue